import { render, staticRenderFns } from "./BookEventRegisterInterest.vue?vue&type=template&id=20bdeba4&"
import script from "./BookEventRegisterInterest.vue?vue&type=script&lang=js&"
export * from "./BookEventRegisterInterest.vue?vue&type=script&lang=js&"
import style0 from "./BookEventRegisterInterest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports